import { useMemo } from 'react';

/**
 * Returns unique values for each specified field from the current list of items.
 * Useful for dynamically populating filter dropdowns based on visible/filtered data.
 */
export function useDynamicFilterOptions<T extends Record<string, any>>(
  items: T[],
  fields: (keyof T)[]
) {
  return useMemo(() => {
    const options: Record<string, any[]> = {};
    fields.forEach((field) => {
      options[field as string] = Array.from(
        new Set(items.map((item) => item[field]))
      ).filter((v) => v !== undefined && v !== null);
    });
    return options;
  }, [items, fields]);
} 